import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'next-i18next';
import { ExpandButton } from '../../../../../components/ExpandButton/index.js';
import { Container } from '../../../../../components/Newsletter/LayerContentAnniversary/components/Conditions/components/Container.js';
import { useBooleanToggle } from '../../../../../hooks/useBooleanToggle/useBooleanToggle.js';
import { CollapsibleContent, List, ListItem } from '../../../../../primitives/index.js';
export const Conditions = /*#__PURE__*/_styled(({
  ...restProps
}) => {
  const {
    t
  } = useTranslation('newsletterVoucherAnniversary');
  const list = t('legal.list', {
    returnObjects: true
  });
  const [isExpanded, handleExpand] = useBooleanToggle();
  return _jsx(Container, {
    ...restProps,
    children: _jsx(CollapsibleContent, {
      hiddenContent: _jsx(List, {
        spacing: "none",
        children: list.map((value, i) => _jsx(ListItem, {
          children: value
        }, i))
      }),
      expanded: isExpanded,
      controls: _jsx(ExpandButton, {
        onClick: handleExpand,
        isExpanded: isExpanded,
        translations: {
          showLess: t('legal.hideConditions'),
          showMore: t('legal.showConditions')
        }
      })
    })
  });
}, process.env.NODE_ENV === "production" ? {
  target: "e1bgtkkk0"
} : {
  target: "e1bgtkkk0",
  label: "Conditions"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWlCRyIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGpzeCBhcyBfanN4IH0gZnJvbSBcIkBlbW90aW9uL3JlYWN0L2pzeC1ydW50aW1lXCI7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyB1c2VUcmFuc2xhdGlvbiB9IGZyb20gJ25leHQtaTE4bmV4dCc7XG5pbXBvcnQgeyBFeHBhbmRCdXR0b24gfSBmcm9tICcuLi8uLi8uLi8uLi8uLi9jb21wb25lbnRzL0V4cGFuZEJ1dHRvbi9pbmRleC5qcyc7XG5pbXBvcnQgeyBDb250YWluZXIgfSBmcm9tICcuLi8uLi8uLi8uLi8uLi9jb21wb25lbnRzL05ld3NsZXR0ZXIvTGF5ZXJDb250ZW50QW5uaXZlcnNhcnkvY29tcG9uZW50cy9Db25kaXRpb25zL2NvbXBvbmVudHMvQ29udGFpbmVyLmpzJztcbmltcG9ydCB7IHVzZUJvb2xlYW5Ub2dnbGUgfSBmcm9tICcuLi8uLi8uLi8uLi8uLi9ob29rcy91c2VCb29sZWFuVG9nZ2xlL3VzZUJvb2xlYW5Ub2dnbGUuanMnO1xuaW1wb3J0IHsgQ29sbGFwc2libGVDb250ZW50LCBMaXN0LCBMaXN0SXRlbSB9IGZyb20gJy4uLy4uLy4uLy4uLy4uL3ByaW1pdGl2ZXMvaW5kZXguanMnO1xuZXhwb3J0IGNvbnN0IENvbmRpdGlvbnMgPSBzdHlsZWQoKHsgLi4ucmVzdFByb3BzIH0pID0+IHtcbiAgICBjb25zdCB7IHQgfSA9IHVzZVRyYW5zbGF0aW9uKCduZXdzbGV0dGVyVm91Y2hlckFubml2ZXJzYXJ5Jyk7XG4gICAgY29uc3QgbGlzdCA9IHQoJ2xlZ2FsLmxpc3QnLCB7XG4gICAgICAgIHJldHVybk9iamVjdHM6IHRydWUsXG4gICAgfSk7XG4gICAgY29uc3QgW2lzRXhwYW5kZWQsIGhhbmRsZUV4cGFuZF0gPSB1c2VCb29sZWFuVG9nZ2xlKCk7XG4gICAgcmV0dXJuIChfanN4KENvbnRhaW5lciwgeyAuLi5yZXN0UHJvcHMsIGNoaWxkcmVuOiBfanN4KENvbGxhcHNpYmxlQ29udGVudCwgeyBoaWRkZW5Db250ZW50OiBfanN4KExpc3QsIHsgc3BhY2luZzogXCJub25lXCIsIGNoaWxkcmVuOiBsaXN0Lm1hcCgodmFsdWUsIGkpID0+IChfanN4KExpc3RJdGVtLCB7IGNoaWxkcmVuOiB2YWx1ZSB9LCBpKSkpIH0pLCBleHBhbmRlZDogaXNFeHBhbmRlZCwgY29udHJvbHM6IF9qc3goRXhwYW5kQnV0dG9uLCB7IG9uQ2xpY2s6IGhhbmRsZUV4cGFuZCwgaXNFeHBhbmRlZDogaXNFeHBhbmRlZCwgdHJhbnNsYXRpb25zOiB7XG4gICAgICAgICAgICAgICAgICAgIHNob3dMZXNzOiB0KCdsZWdhbC5oaWRlQ29uZGl0aW9ucycpLFxuICAgICAgICAgICAgICAgICAgICBzaG93TW9yZTogdCgnbGVnYWwuc2hvd0NvbmRpdGlvbnMnKSxcbiAgICAgICAgICAgICAgICB9IH0pIH0pIH0pKTtcbn0pIGBgO1xuLy8jIHNvdXJjZU1hcHBpbmdVUkw9aW5kZXguanMubWFwIl19 */");